// $(document).ready(function() {
//   var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
 
//   if(viewedProducts.length > 0){
//       $('.recently_view_title').show();
//     $('.section_recently_view').show();
//     console.log(viewedProducts);
//     loadAjaxTemplate(viewedProducts);
//       }
// });

// $(document).on('click', 'a.custom_recently_view', function(e) {
//   var productId = $(this).data('product-id');
//   var productHandle = $(this).data('handle');

//   var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
//   var existingProductIndex = viewedProducts.findIndex(function(product) {
//     return product.id === productId;
//   });
//   if (existingProductIndex !== -1) {
//     viewedProducts.splice(existingProductIndex, 1);
//   }
// if(productHandle){
//  viewedProducts.unshift(productHandle); 
// }
//   localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
// });


// function loadAjaxTemplate(viewedProducts) {
//   $.ajax({
//     url: '/collections/all?view=ajax&products=' + viewedProducts,
//     method: 'GET',
//     dataType: 'html',
//     success: function (response) {
//       console.log(response);
//       $('#recently-viewed').html(response);
//     },
//     error: function (xhr, status, error) {
//       console.log(error);
//     }
//   });
// }



$(document).ready(function () {
    var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];

    console.log('ALL PRODUCTS:', viewedProducts);

    if (viewedProducts.length > 1) {
        $('.recently_view_title').show();
        $('.section_recently_view').show();
        loadAjaxTemplate(viewedProducts);
    }
});

$(document).on('click', 'a.custom_recently_view', function () {
    var productHandle = $(this).data('handle');

    var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];

    var index = viewedProducts.indexOf(productHandle);
    if (index !== -1) {
        viewedProducts.splice(index, 1);
    }

    if (productHandle) {
        viewedProducts.unshift(productHandle);
    }

    localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
});

function loadAjaxTemplate(viewedProducts) {
    $.ajax({
        url: '/collections/all?view=ajax&products=' + viewedProducts.join(','),
        method: 'GET',
        dataType: 'html',
        success: function (response) {
            $('#recently-viewed').html(response);

            // 🔥 DOM load hone ke baad last item hide
            hideLastItem();
        },
        error: function (xhr, status, error) {
            console.log(error);
        }
    });
}

function hideLastItem() {
    var $items = $('#recently-viewed').children();

    console.log('TOTAL RENDERED ITEMS:', $items.length);

    if ($items.length > 0) {
        var $hiddenItem = $items.last();

        console.log('HIDDEN ITEM (LAST INDEX):', $hiddenItem);

        $hiddenItem.hide();
    }
}
